module.exports = __webpack_public_path__ + "static/media/Central-mobile.064bec00.jpg";